import { NET_EQUITY_RANGES, type NetEquityRange } from '../constants/business-finances';

const netEquityRangeSet = new Set<string>(NET_EQUITY_RANGES);

export function isNetEquityRange(value: string): value is NetEquityRange {
  return netEquityRangeSet.has(value);
}

export function toNetEquityRange(value: string | null | undefined): NetEquityRange | null {
  if (typeof value !== 'string' || !isNetEquityRange(value)) return null;
  return value;
}
